import { qsa } from "@fluorescent/dom";

/**
 * delayOffset takes an array of selectors and sets the `--delay-offset-multiplier` variable in the correct order
 * @param {HTMLElement} node The section element
 * @param {string[]} items Array of animation item selectors
 * @param {number} [offsetStart=0] Starting offset multiplier
 * @returns {void}
 */
export default (node, items, offsetStart = 0) => {
  let delayOffset = offsetStart;
  items.forEach(selector => {
    const items = qsa(selector, node);
    items.forEach(item => {
      item.style.setProperty("--delay-offset-multiplier", delayOffset);
      delayOffset++;
    });
  });
};
